/* WBD cart handoff. Enable only after signed webhook + paid-order verification. */
(() => {
  const config = window.WBDCheckout;
  if (!config?.enabled || config.origin !== 'https://checkout.warmbydesign.com') return;
  const giftIds = new Set(['47723843518615', '47715176841367']);
  const giftProps = {_kit:'gift-room-pair',_wbd_launch_kit:'gift','Room Pair Bonus':'Free with 2+ lamps'};
  const normal = value => String(value || '').trim().toUpperCase();
  function savedCodes() {
    try {const codes=JSON.parse(localStorage.getItem('wbdDiscountCodes')||'[]');return Array.isArray(codes)?codes.map(normal).filter(Boolean):[];} catch {return [];}
  }
  function supportedProperties(item) {
    const entries=Object.entries(item.properties||{}).filter(([,v])=>v!==''&&v!=null);
    return !entries.length || (giftIds.has(String(item.variant_id))&&item.quantity===1&&entries.every(([k,v])=>giftProps[k]===v));
  }
  function attribution(privacy){const attributes={};
      if(privacy.analytics||privacy.marketing){
        try{
          const key='wbd_checkout_attribution_v1',now=Date.now(),url=new URL(location.href);
          let history=JSON.parse(localStorage.getItem(key)||'null');
          if(!history||history.expires<now)history={};
          const touch={};for(const name of ['source','medium','campaign','content','term']){const v=url.searchParams.get('utm_'+name);if(v)touch[name]=v.slice(0,240);}
          if(privacy.marketing)for(const name of ['gclid','gbraid','wbraid','fbclid']){const v=url.searchParams.get(name);if(v)touch[name]=v.slice(0,240);}
          if(Object.keys(touch).length){touch.landing_page=url.origin+url.pathname;touch.ts=String(now);history.ft=history.ft||touch;history.lt=touch;history.expires=now+30*86400000;localStorage.setItem(key,JSON.stringify(history));}
          for(const kind of ['ft','lt'])for(const [k,v]of Object.entries(history[kind]||{}))attributes['oa_'+kind+'_'+k]=v;
        }catch{}
      }
    return attributes;
  }
  function rememberAttribution(){const p=window.Shopify?.customerPrivacy;if(navigator.globalPrivacyControl)return;attribution({analytics:p?.analyticsProcessingAllowed?.()===true,marketing:p?.marketingAllowed?.()===true});}
  rememberAttribution();
  document.addEventListener('visitorConsentCollected',rememberAttribution);
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)rememberAttribution();});
  const storeOrigin=window.location.origin||location.origin;
  const cartRoot=window.Shopify?.routes?.root||'/';
  const cartPath=cartRoot+'cart';
  function checkoutEntry(href){
    try{
      const url=new URL(href,storeOrigin);
      if(url.origin!==storeOrigin)return null;
      const native=['/checkout','/cart/checkout',cartRoot+'checkout',cartRoot+'cart/checkout'].includes(url.pathname.replace(/\/$/,''));
      const bridge=url.pathname===cartPath&&url.searchParams.get('whop_checkout')==='1';
      if(native||bridge)return{codes:url.searchParams.get('discount')||''};
      const prefix=[cartRoot+'discount/','/discount/'].find(path=>url.pathname.startsWith(path));
      if(prefix){
        const redirect=new URL(url.searchParams.get('redirect')||'/cart',storeOrigin);
        if(redirect.origin===storeOrigin&&['/checkout','/cart/checkout',cartRoot+'checkout',cartRoot+'cart/checkout'].includes(redirect.pathname))return{codes:decodeURIComponent(url.pathname.slice(prefix.length))};
      }
    }catch{}
    return null;
  }
  function rewriteCheckoutLinks(){
    for(const link of document.querySelectorAll?.('a[href]')||[]){
      const entry=checkoutEntry(link.getAttribute('href'));
      if(!entry)continue;
      const url=new URL(cartPath,storeOrigin);url.searchParams.set('whop_checkout','1');
      if(entry.codes)url.searchParams.set('discount',entry.codes);
      if(link.href!==url.href)link.href=url.href;
    }
  }
  rewriteCheckoutLinks();
  if(typeof MutationObserver!=='undefined')new MutationObserver(rewriteCheckoutLinks).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
  let leaving = false;
  // A restored cart page must allow another checkout after returning via Back.
  window.addEventListener('pageshow',event=>{if(event.persisted)leaving=false;});
  async function readCart() {
    // A cart GET is safe to retry; a brief network failure should not discard
    // the customer's card/wallet checkout in favor of the native fallback.
    for (let attempt=0;attempt<2;attempt++) {
      try {
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{cache:'no-store',signal:AbortSignal.timeout(7000)});
        if(!response.ok)throw Error('Cart unavailable');
        return await response.json();
      } catch(error) {if(attempt===1)throw error;}
    }
  }
  const copy={title:'Checkout needs another try',review:'Review your bag before checkout',unavailable:'We could not open secure checkout. Your bag is saved. Please try again.',unsupported:'We could not transfer all the details in this bag to secure checkout. Your bag is saved. Return to your bag or contact us for help.',retry:'Try secure checkout again',back:'Return to bag',help:'Contact Warm by Design',syncing:'Your cart is still updating. Please wait a moment and try checkout again.',...(config.messages||{})};
  function showFailure(unsupported,requestedCodes=''){
    leaving=false;
    document.getElementById('wbd-checkout-recovery')?.remove();
    const dialog=document.createElement('dialog');dialog.id='wbd-checkout-recovery';dialog.setAttribute('aria-labelledby','wbd-checkout-recovery-title');
    dialog.style.cssText='max-width:420px;width:calc(100% - 32px);padding:28px;border:1px solid #d8d5cc;background:#faf9f6;color:#131314;font-family:inherit';
    const title=document.createElement('h2');title.id='wbd-checkout-recovery-title';title.textContent=unsupported?copy.review:copy.title;
    const message=document.createElement('p');message.textContent=unsupported?copy.unsupported:copy.unavailable;dialog.append(title,message);
    function button(label,action){const node=document.createElement('button');node.type='button';node.textContent=label;node.style.cssText='display:block;width:100%;padding:13px;margin:10px 0;cursor:pointer';node.addEventListener('click',()=>{dialog.close();dialog.remove();action?.();});dialog.appendChild(node);}
    if(!unsupported)button(copy.retry,()=>void openCheckout(requestedCodes));
    button(copy.back);
    const help=document.createElement('a');help.href='/pages/contact';help.textContent=copy.help;dialog.appendChild(help);
    dialog.addEventListener('close',()=>dialog.remove());document.body.appendChild(dialog);dialog.showModal();
  }
  if(new URLSearchParams(location.search).get('checkout_retry')==='1')showFailure(false,new URLSearchParams(location.search).get('discount')||'');
  async function openCheckout(requestedCodes='') {
    if (leaving) return;
    leaving = true;
    let codes=[...savedCodes(),...requestedCodes.split(',').map(normal)].filter(Boolean);
    try {
      // The theme's gift/cart mutations must settle before reading the cart.
      const deadline=Date.now()+7000;
      while(document.documentElement.hasAttribute('data-wbd-cart-syncing')) {
        if(Date.now()>deadline){ leaving=false; window.alert(copy.syncing); return; }
        await new Promise(resolve=>setTimeout(resolve,80));
      }
      const cart=await readCart();
      const applied=[...(cart.discount_codes||[]).filter(c=>c.applicable).map(c=>c.code),...(cart.cart_level_discount_applications||[]).filter(d=>d.type==='discount_code').map(d=>d.title),...(cart.items||[]).flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>a.discount_application).filter(d=>d?.type==='discount_code').map(d=>d.title))].map(normal);
      codes=[...new Set([...codes,...applied,...requestedCodes.split(',').map(normal)].filter(Boolean))];
      if(!cart.items?.length||cart.items.length>20||cart.currency!=='USD'||cart.note||cart.total_price>250000)throw Error('Native checkout required');
      if(codes.length>5||codes.join(',').length>64||codes.some(c=>!/^[-A-Z0-9_]+$/.test(c)))throw Error('Preserve discounts in native checkout');
      // Preserve known app metadata; unknown commercial cart details need review.
      if(Object.keys(cart.attributes||{}).some(k=>!k.startsWith('oa_')&&!['igId','bsure-attribute','_wbd_mailroom_session'].includes(k)))throw Error('Preserve cart details');
      if(cart.items.some(i=>i.selling_plan_allocation||i.gift_card||!supportedProperties(i)||!Number.isSafeInteger(i.variant_id)||!Number.isSafeInteger(i.quantity)||i.quantity<1||i.quantity>10))throw Error('Native checkout required');
      // Shopify can split a normal variant into multiple lines when quantity or
      // automatic discounts change. The quote API accepts variant quantities,
      // so combine plain merchandise lines instead of losing card/wallet checkout.
      // Gift lines keep their one-per-cart rule and all validation above still applies.
      const checkoutItems = new Map();
      for (const item of cart.items) {
        const previous = checkoutItems.get(item.variant_id);
        if (previous) {
          if (giftIds.has(String(item.variant_id)) || previous.quantity + item.quantity > 10) throw Error('Distinct cart lines require native checkout');
          previous.quantity += item.quantity;
        } else {
          checkoutItems.set(item.variant_id, {variant_id: item.variant_id, quantity: item.quantity});
        }
      }
      const privacy=window.Shopify?.customerPrivacy;
      const permitted=!navigator.globalPrivacyControl;
      const context={attributes:{...cart.attributes},privacy:{analytics:permitted&&privacy?.analyticsProcessingAllowed?.()===true,marketing:permitted&&privacy?.marketingAllowed?.()===true}};
      Object.assign(context.attributes,attribution(context.privacy));
      if(context.privacy.marketing){
        try{const session=await Promise.race([Promise.resolve(window.WBDMailroom?.emailSession?.()),new Promise(resolve=>setTimeout(()=>resolve(null),2500))]);if(session?.sessionId)context.attributes._wbd_mailroom_session=session.sessionId;}catch{}
      }
      // Capture listener bypasses the theme's bubbling listeners, so explicitly
      // announce checkout intent to the existing first-party Mailroom bridge.
      window.dispatchEvent(new CustomEvent('wbd:checkout-started',{detail:{items:cart.items,cartId:cart.token,currency:cart.currency}}));
      const form=document.createElement('form');form.method='POST';form.action=config.origin+'/start';form.hidden=true;
      for(const [name,value]of Object.entries({items:[...checkoutItems.values()].map(i=>`${i.variant_id}:${i.quantity}`).join(','),coupon:codes.join(','),context:JSON.stringify(context)})){
        const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.appendChild(input);
      }
      document.body.appendChild(form);form.submit();
    }catch(error){showFailure(/native checkout|preserve|cart details|distinct cart/i.test(error?.message||''),codes.join(','));}
  }
  document.addEventListener('click',event=>{
    const control=event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href],[data-checkout-btn],[data-discount-checkout]');
    if(!control||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const entry=control.tagName==='A'?checkoutEntry(control.href):null;
    if(control.tagName==='A'&&!entry)return;
    event.preventDefault();event.stopImmediatePropagation();void openCheckout(entry?.codes||'');
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement))return;
    const action=new URL(form.action,window.location.origin);
    if(!checkoutEntry(action.href)&&event.submitter?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();void openCheckout(checkoutEntry(action.href)?.codes||'');
  },true);
  const entry=checkoutEntry(location.href||storeOrigin+cartPath+location.search);
  if(entry&&new URLSearchParams(location.search).get('whop_checkout')==='1')void openCheckout(entry.codes);
})();
